import CustomTable from "../common/CustomTable";
import { useRecoilValue, useSetRecoilState } from "recoil";
import {
  inventoryEntryPartIdState,
  modalTitle,
  selectedBarcodeHistoryState,
} from "../../utils/atoms/atoms";
import React from "react";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { getAttdMonthById } from "../../api/attendance";
import { useEffect } from "react";
import { getInOutPartEntries } from "../../api/inventory";
import { inoutColumns } from "../../utils/table/inOutCols";
import { getPendingBarcodesHistory } from "../../api/inventory-reports";
import { inoutTanotiColumns } from "../../utils/table/inOutTanotiCols";

const InventoryReportHistoryModalBody = () => {
  const queryClient = useQueryClient();
  const selectedBarcodeHistory = useRecoilValue(selectedBarcodeHistoryState);
  const setModalTitle = useSetRecoilState(modalTitle);
  const {
    isLoading,
    data: partEntries,
    isSuccess,
  } = useQuery({
    queryKey: ["selected_barcode", selectedBarcodeHistory],
    queryFn: () => getPendingBarcodesHistory(selectedBarcodeHistory),
  });

  const partEntryMutation = useMutation({
    mutationFn: async (barcodeValue: any) => {
      return getPendingBarcodesHistory(barcodeValue);
    },
    onSuccess: (data) => {
      queryClient.setQueryData(["selected_barcode"], data);
      if (data.entries[0]?.emp_name) {
        setModalTitle(
          `${data.entries[0].part_name} - ${data.entries[0].drawing}`
        );
      } else {
        setModalTitle("Data not found");
      }
    },
  });

  useEffect(() => {
    if (selectedBarcodeHistory) {
      partEntryMutation.mutate(selectedBarcodeHistory);
    }
  }, [selectedBarcodeHistory]);

  return (
    <React.Fragment>
      {isLoading ? (
        "Loading"
      ) : isSuccess ? (
        <CustomTable
          data={partEntries}
          columns={
            process.env.REACT_APP_COMPANY_NAME === "TANOTI"
              ? inoutTanotiColumns
              : inoutColumns
          }
        />
      ) : (
        "Something went wrong"
      )}
    </React.Fragment>
  );
};

export default InventoryReportHistoryModalBody;
